/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamOrganizacniJednotkaNew extends GContentBase<SeznamOrganizacniJednotkaObj> {
        private seznamObj: SeznamOrganizacniJednotkaObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamOrganizacniJednotkaObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamOrganizacniJednotkaNew",
                contentCaption: "jres:33000090",
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_orj}"
                },
                gridSettings: {
                    columnOrder: "zkratka,nazev,poznamka,ofic_nazev,zmenu_prov_txt,dat_zmena,ofic_nazev,ico,uroven_orj_txt,ixs_nad_txt,ixs_orj"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamOrganizacniJednotkaObj extends GAdmSeznamBase {
        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailOrganizacniJednotkaNew", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailOrganizacniJednotkaNew",
                newRecord: isNew,
                ixs_orj: isNew == true ? null : data.ixs_orj
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenSslDenik: {
                    icon: "fa-link",
                    caption: "jres:29808097", //RC 29808097 : Deníky povolené pro organizační jednotku 
                    run: (ev, ctx) => {
                        var activeRow = this.grid.ggrid("activeRow");
                        if (activeRow)
                            Gordic.Adm.WebControls.OrganizacniJednotka.openSeznamOrganizacniJednotkaDenikSsl(activeRow);
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenSslDenik*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*", "actOpenSslDenik*"])
        }

        createFilterForm() {
            this.filterForm.addRow("Ičo").addField("gselectbox", Gordic.Prefabs.Select.ginsico(), {
                name: "ico",
                model: "model.ico=value.ico",
                dropdown: true,
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.OrganizacniJednotka.list({ filters: filterData }).getView().done((data) => {
                this.setPlatnostColumn(data);
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actOpenSslDenik?.update({ enabled: objArr.count > 0 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.ixs_orj),
                nazev: ""
            }
        }
    }
}